import { isEmpty } from 'lodash';
// Import Store
import { useAppSelector } from 'store';
import { selectMaintenance } from 'store/slices/maintenance';

const useMaintenanceSettings = () => {
    const { startDate, endDate } = useAppSelector(selectMaintenance);

    let hasUpcomingMaintenance = false;
    let isUnderMaintenance = false;

    if (!isEmpty(startDate) && !isEmpty(endDate)) {
        const startDateTime = new Date(startDate!).getTime();
        const endDateTime = new Date(endDate!).getTime();
        const nowTime = new Date().getTime();

        if (startDateTime > nowTime) {
            hasUpcomingMaintenance = true;
        } else if (endDateTime > nowTime) {
            isUnderMaintenance = true;
        }
    }

    return {
        startDate,
        endDate,
        hasUpcomingMaintenance,
        isUnderMaintenance,
    };
};

export default useMaintenanceSettings;
